<template>
  <BaseScreen v-bind="screen">
    <BaseAlert
      v-if="isThanksVisible"
      v-bind="thanks"
      slot="middle"
    />
    <BaseAlert
      v-if="isErrorVisible"
      v-bind="error"
      slot="middle"
    />
    <BaseForm
      ref="form"
      v-bind="form"
      class="screen__form"
      @submit="onFormSubmit"
    >
      <i18n
        path="texts.feedbackTerms"
        tag="div"
        class="form__terms"
        slot="content"
      >
        <button
          type="button"
          class="form__terms-link"
          v-text="$t('texts.termsFeedbackConsent')"
          @click="showTermsModal"
        />
      </i18n>
    </BaseForm>
    <ModalTerms
      v-if="isTermsModalVisible"
      v-bind="termsModal"
      slot="root"
      class="screen__overlay"
      @close="hideTermsModal"
    />
  </BaseScreen>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import CONSTANTS from '@/helpers/constants';

import screenMixin from '@/mixins/screen';
import formMixin from '@/mixins/form';
import mailMixin from '@/mixins/mail';

import ModalTerms from '@/components/ModalTerms.vue';
import BaseForm from '@/components/BaseForm.vue';
import FieldName from '@/components/FieldName.vue';
import FieldPhone from '@/components/FieldPhone.vue';

export default {
  name: 'AudioSendScreen',
  mixins: [screenMixin, formMixin, mailMixin],
  components: {
    ModalTerms,
    BaseForm,
  },
  data() {
    return {
      values: {
        fullname: '',
        phone: '+7',
      },
      isTermsModalVisible: false,
    };
  },
  computed: {
    ...mapState('feedback', [
      'audio',
    ]),
    titleText() {
      return this.$t('titles.leaveContacts');
    },
    screenCase() {
      if (this.isThanksVisible) {
        return CONSTANTS.STEP_FEEDBACK_SENDED;
      }
      if (this.isErrorVisible) {
        return CONSTANTS.STEP_HARDWARE_ERROR;
      }
      if (this.isTermsModalVisible) {
        return CONSTANTS.STEP_TERMS_MODAL;
      }
      return CONSTANTS.STEP_SEND_AUDIO;
    },
    thanks() {
      return {
        icon: {
          name: 'success',
          theme: 'primary',
          size: 'l',
        },
        title: {
          text: this.$t('titles.thanks'),
          size: 'l',
        },
        description: {
          text: this.$t('texts.thanksForFeedback'),
          size: 'l',
        },
        actions: [
          {
            text: this.$t('actions.home'),
            action: this.goToHomeScreen,
            view: 'outlined',
          },
        ],
      };
    },
    error() {
      return {
        icon: {
          name: 'important',
          theme: 'secondary',
          size: 'l',
        },
        title: {
          text: this.$t('titles.badHardware'),
          size: 'l',
        },
        description: {
          text: this.$t('texts.operationNotPossible'),
          size: 'l',
        },
        actions: [
          {
            text: this.$t('actions.home'),
            action: this.goToHomeScreen,
            view: 'outlined',
          },
        ],
      };
    },
    form() {
      return {
        values: this.values,
        fields: [
          {
            is: FieldName,
            name: 'fullname',
          },
          {
            is: FieldPhone,
            name: 'phone',
          },
        ],
        actions: [
          {
            type: 'submit',
            text: this.$t('actions.sendFeedback'),
          },
        ],
      };
    },
    termsModal() {
      return {
        type: 'feedback',
        title: {
          text: this.$t('titles.feedbackTerms'),
          size: 'm',
          isNormal: true,
        },
      };
    },
  },
  created() {
    this.initActions([
      [CONSTANTS.ACTION_SHOW_MODAL, this.showTermsModal],
      [CONSTANTS.ACTION_CLOSE, this.hideTermsModal],
    ]);
  },
  methods: {
    ...mapActions('feedback', [
      'sendAudio',
    ]),
    async onFormSubmit() {
      if (this.isPending) return;
      try {
        this.showPending();
        const result = await this.sendAudio(this.values);
        this.sendInfoToMail(result);
      } catch {
        this.sendFeedbackToMail(this.values);
      }
    },
    sendInfoToMail({ name, phoneNumber, resultFtpFile }) {
      const email = process.env.VUE_APP_FEEDBACK_EMAIL;
      const subject = this.$t('titles.feedbackWasLeaved');
      const body = [
        [this.$t('fields.fullnameLabel'), name],
        [this.$t('fields.phoneLabel'), phoneNumber],
        [this.$t('fields.fileLabel'), resultFtpFile],
      ]
        .map((el) => el.join(': '))
        .join('\n');

      return this.sendMail(email, subject, body); // функция из миксина
    },
    sendFeedbackToMail({ fullname, phone }) {
      const email = process.env.VUE_APP_FEEDBACK_EMAIL;
      const subject = this.$t('titles.feedbackWasLeaved');
      const file = this.audio?.fullpath;
      const body = [
        [this.$t('fields.fullnameLabel'), fullname],
        [this.$t('fields.phoneLabel'), phone],
      ]
        .map((el) => el.join(': '))
        .join('\n');

      return this.sendMail(email, subject, body, file); // функция из миксина
    },
    showTermsModal() {
      this.isTermsModalVisible = true;
    },
    hideTermsModal() {
      this.isTermsModalVisible = false;
    },
  },
};
</script>
